import Vue from 'vue';
import Vuelidate from 'vuelidate';
Vue.use(Vuelidate);


//////////////////
// WEBPACK FOOTER
// ./plugins/vuelidate.js
// module id = ./plugins/vuelidate.js
// module chunks = 82